

<!-- Start of Quick search common component -->
  <app-quick-search 
    [DefaultFilterArray]="brokerMappingService.DefaultFilterArray"
    [QuickSearchFilterArray]="quickFilterArray"
    (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)">
  </app-quick-search>
<!-- end of Quick search common component -->

<p-confirmDialog id="brokerconfirmDialog" [style]="{width: '30vw',minHeight:'100px'}" appendTo="body"
showEffect="fade" focusOnShow="false" styleClass="broker-confirmDialog"></p-confirmDialog>
<!--Filter Code  -->
<div class="col-lg-12 nopadding">
    <app-filter-panel  id="BrokerMappingTable" [GridColumns]="columns" [DefaultFilterArray]="brokerMappingService.DefaultFilterArray"
    (FilterEvent)="FilterApplyFilterEvent($event)">
  </app-filter-panel>
</div>

<!-- Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(brokerMappingService.isLoadingResults){
    <div class="example-loading-shade">
    @if(brokerMappingService.isLoadingResults){<mat-spinner></mat-spinner>}
    </div>}
<div class="card" (mouseup)="commonColService.stopDragging()" (mouseleave)="commonColService.stopDragging()">
  <p-contextMenu #cm [model]="commonColService.menuItems" appendTo="body" styleClass="column-context-menu"></p-contextMenu> 
    <p-table 
      id="BrokerMappingTable"
      alwaysShowPaginator="true" 
      paginatorPosition="both" 
      showCurrentPageReport="true"
      [value]="brokerMappingService.dataset" 
      [class.table-frozen]="commonColService.isFrozenColumns"
      [columns]="commonColService.selectedColumns" 
      [resizableColumns]="true" 
      columnResizeMode="expand"
      [(selection)]="selectedRow"
      [paginator]="true"
      appendTo="body"
      (onPage)="changePage($event)"
      (onSort)="sort($event)"
      sortMode="multiple"
      [rows]="constantService.DEFAULT_ROWSIZE" 
      [totalRecords]="brokerMappingService.totalRecords" 
      [pageLinks]="constantService.DEFAULT_PAGELINKS"
      [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"  
      [lazy]="true" 
      [scrollable]="true" 
      scrollHeight="60vh"
      [reorderableColumns]="true"
      (onColReorder)="commonColService.onColumnsReordered($event, dt)"
      styleClass="tableData brokerMapTable"
      #dt>
      <ng-template pTemplate="caption">
        <div class="addbrokerTitle">
            <button pButton id="btn_add_fdid"  type="button" class="pull-left cls-button" (click)="onAdd()">Add Broker Mapping</button>
        </div>
    </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{emptytbldatamsg}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track col;){
          <th [attr.id]="'col-' + col.field" pResizableColumn [pSortableColumn]="col.field"
            [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' " pFrozenColumn pReorderableColumn
            [frozen]="col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen"                
            [style.left]="(col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
            [style.background-color]="col.frozen && !commonColService.selectedFields.includes(col.field) ? 'sortClass' : null"
            [class.selected-header]="commonColService.selectedFields.includes(col.field)"
            (mousedown)="commonColService.onHeaderMouseDown($event, col.field)"
            (mouseenter)="commonColService.onHeaderMouseEnter(col.field)"
            (contextmenu)="commonColService.onHeaderContextMenu($event, col.field,contextMenuItems, dt)">
            <div class="header-cell-content">
              <span [class.excel-cursor-span]="(col.header | lowercase) !== 'action'">
            {{col.header}}
            @if((col.header | lowercase) !== 'action'){
            <p-sortIcon [field]="col.field"></p-sortIcon>}
            </span>
            @if(col.frozen) {
            <i class="pi pi-lock" style="font-size: 0.85rem; color: #000;"></i>
            }
            </div>
          </th>}
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="ri" let-ri="rowIndex">
        <tr [pSelectableRow]="row" [pSelectableRowIndex]="ri"
          [ngClass]="(row['action'] | lowercase) == 'd' ? 'ui-widget-deleted-row' : 'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
          <td class="ui-resizable-column" pFrozenColumn 
          [frozen]="col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen"
          alignFrozen="left"
          [style.left]="(col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
          [style.background-color]="selectedRow?.includes(row)? '#88c0eb': (col.frozen ? '#e2f0d9' : null)" 
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay' : '' ">
            @if(col.header === 'Action'){
            <span>
              <p-button [id]="'ViewBtn'+row['id']" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" matTooltipPosition="above"
                appendTo="body" icon="fa fa-xxx fa-eye" (click)="onView(ri,row);"></p-button>
              <p-button [id]="'EditBtn'+row['id']"   class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Edit" matTooltipPosition="above"
                appendTo="body" icon="fa fa-xxx fa-edit" (click)="onEdit(ri,row);"></p-button>
              <p-button [id]="'DeleteBtn'+row['id']"  class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" matTooltipPosition="above"
                appendTo="body" icon="fa fa-xxx fa-trash" (click)="onDelete(ri,row)"></p-button>
            </span>}
             <!-- set String -->
              @if(col.header != 'Action' && col.datatype !='Date'){
             <span>
                {{row[col.field] }}
            </span>}
            <!-- set Date -->
             @if(col.header != 'Action' && col.datatype=='Date'){
            <span>
                {{row[col.field] | date:'yyyy/MM/dd h:mm:ss'}}
            </span>}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorright">
        <button  [matTooltip]="this.userService.enableFileExport()?
                    'Export':'Export service is disabled'"
                     [matTooltipShowDelay]="1000" id="btn_brokermapping_export" class="exportBtn"
        (click)="exportToCSV()" type="button">Export  <i class="fa fa-download" aria-hidden="true"></i> 
        @if(isExportToCSV){
        <img style="text-align:right" alt="exportToCSV"
        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        }</button>
        Total Records: {{brokerMappingService.dataset.length == 0? 0 : brokerMappingService.totalRecords}}
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        <!-- Page No : {{pageNumber }} -->
        Showing {{brokerMappingService.dataset.length == 0? 0 : brokerMappingService.startLimit + 1}} to {{brokerMappingService.dataset.length
            < brokerMappingService.rowcount ? brokerMappingService.dataset.length < brokerMappingService.startLimit ? brokerMappingService.endLimit : brokerMappingService.dataset.length : brokerMappingService.endLimit}} entries
      </ng-template>
    </p-table>
  </div>
    <br>
    <br>
  </div>
<app-add-broker-mapping [columns]="GridColumns"></app-add-broker-mapping>
<app-view-broker-mapping [columns]="GridColumns" [selectedRow]="selectedRow[0]"></app-view-broker-mapping>
<app-edit-broker-mapping [columns]="GridColumns" ></app-edit-broker-mapping>
